import { render } from "./TagsInput.vue?vue&type=template&id=013ec16e"
import script from "./TagsInput.vue?vue&type=script&lang=ts"
export * from "./TagsInput.vue?vue&type=script&lang=ts"

import "./TagsInput.vue?vue&type=style&index=0&id=013ec16e&lang=scss"
script.render = render

export default script